import React from "react";

const Filters = ({ filters, setFilters }) => {
  return (
    <div className="filters">
      <select value={filters.category} onChange={(e) => setFilters((prev) => ({ ...prev, category: e.target.value }))}>
        <option value="">All Categories</option>
        <option value="Food">Food</option>
        <option value="Bills">Bills</option>
        <option value="Shopping">Shopping</option>
        <option value="Transport">Transport</option>
      </select>
      <input
        type="date"
        value={filters.date}
        onChange={(e) => setFilters((prev) => ({ ...prev, date: e.target.value }))}
      />
    </div>
  );
};

export default Filters;
